import React from "react";

export default function () {

    return <svg xmlns="http://www.w3.org/2000/svg" width="19.475" height="19.475" viewBox="0 0 19.475 19.475">
        <path id="Path_998" data-name="Path 998" d="M19.734,14.748H16.247V11.261a.749.749,0,0,0-1.5,0v3.488H11.261a.717.717,0,0,0-.749.749.725.725,0,0,0,.749.749h3.488v3.488a.726.726,0,0,0,.749.749.745.745,0,0,0,.749-.749V16.247h3.488a.749.749,0,0,0,0-1.5Z" transform="translate(-5.76 -5.76)" fill="#1f1f1f"/>
        <path id="Path_999" data-name="Path 999" d="M13.113,4.686a8.423,8.423,0,1,1-5.96,2.467,8.371,8.371,0,0,1,5.96-2.467m0-1.311a9.738,9.738,0,1,0,9.738,9.738,9.736,9.736,0,0,0-9.738-9.738Z" transform="translate(-3.375 -3.375)" fill="#1f1f1f"/>
    </svg>;

}
